import { Plane } from '@react-three/drei'

export const StaticPlanes = (): JSX.Element => {
  return (
    <>
      <Plane args={[20, 20]} rotation={[-Math.PI / 2, 0, 0]}>
        <meshStandardMaterial color={'grey'}></meshStandardMaterial>
      </Plane>
      <Plane args={[20, 20]} rotation={[0, 0, 0]}>
        <meshStandardMaterial color={'lightgrey'}></meshStandardMaterial>
      </Plane>
    </>
  )
}
